import { SELECIONAR_DESTINO } from '../types';

export default function selecionarDestino (destino) {
  return {
    type: SELECIONAR_DESTINO,
    payload: destino
  }
}
